/**
 * Sum portal stage buckets for one calendar year.
 * Ignores claim-shaped rows accidentally mixed into appStageCountsByMonth.
 */
export function sumAppStageCountsForYear(aggregates, year) {
  const stageTotals = {
    stage01: 0,
    stage02: 0,
    stage02A: 0,
    stage04: 0,
    stage05: 0,
  };

  if (!Array.isArray(aggregates) || !Number.isFinite(Number(year))) {
    return stageTotals;
  }

  const targetYear = Number(year);
  aggregates.forEach((aggregate) => {
    if (Number(aggregate?.year) !== targetYear) return;
    if (!Object.prototype.hasOwnProperty.call(aggregate, 'stage05')) return;

    stageTotals.stage01 += Number(aggregate.stage01 || 0);
    stageTotals.stage02 += Number(aggregate.stage02 || 0);
    stageTotals.stage02A += Number(aggregate.stage02A || 0);
    stageTotals.stage04 += Number(aggregate.stage04 || 0);
    stageTotals.stage05 += Number(aggregate.stage05 || 0);
  });

  return stageTotals;
}

export function appStageTotalsHaveValues(stageTotals) {
  if (!stageTotals || typeof stageTotals !== 'object') return false;
  return (
    Number(stageTotals.stage01 || 0) > 0 ||
    Number(stageTotals.stage02 || 0) > 0 ||
    Number(stageTotals.stage02A || 0) > 0 ||
    Number(stageTotals.stage04 || 0) > 0 ||
    Number(stageTotals.stage05 || 0) > 0
  );
}
